"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFilter = void 0;
var react_1 = require("react");
var DataFilterContext_1 = require("../DataFilterContext");
var R = __importStar(require("../../../utils/ramda"));
var useFilter = function (_a) {
  var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
  var filterId = _a.filterId,
    defaultMode = _a.defaultMode,
    _p = _a.defaultOptions,
    defaultOptions = _p === void 0 ? [] : _p,
    _q = _a.defaultOptionsIncluded,
    defaultOptionsIncluded = _q === void 0 ? [] : _q,
    _r = _a.defaultOptionsExcluded,
    defaultOptionsExcluded = _r === void 0 ? [] : _r,
    _s = _a.onReset,
    onReset = _s === void 0 ? R.N : _s;
  var _t = (0, react_1.useContext)(DataFilterContext_1.DataFilterContext),
    tempStates = _t.tempStates,
    filterStates = _t.filterStates,
    defaultStates = _t.defaultStates,
    setState = _t.setState,
    resetEvent = _t.resetEvent,
    translation = _t.translation;
  var isActive = !R.equals((_b = tempStates[filterId]) !== null && _b !== void 0 ? _b : {}, (_c = defaultStates[filterId]) !== null && _c !== void 0 ? _c : {});
  var isUnsaved = !R.equals((_d = tempStates[filterId]) !== null && _d !== void 0 ? _d : {}, (_e = filterStates[filterId]) !== null && _e !== void 0 ? _e : {});
  var mode = (_g = (_f = tempStates[filterId]) === null || _f === void 0 ? void 0 : _f.mode) !== null && _g !== void 0 ? _g : defaultMode;
  var optionsSelected = (_j = (_h = tempStates[filterId]) === null || _h === void 0 ? void 0 : _h.optionsSelected) !== null && _j !== void 0 ? _j : defaultOptions;
  var optionsIncluded = (_l = (_k = tempStates[filterId]) === null || _k === void 0 ? void 0 : _k.optionsIncluded) !== null && _l !== void 0 ? _l : defaultOptionsIncluded;
  var optionsExcluded = (_o = (_m = tempStates[filterId]) === null || _m === void 0 ? void 0 : _m.optionsExcluded) !== null && _o !== void 0 ? _o : defaultOptionsExcluded;
  var defaultState = defaultStates[filterId];
  var setMode = function (newMode) {
    return setState(filterId, {
      id: filterId,
      mode: newMode,
      optionsSelected: optionsSelected,
      optionsIncluded: [],
      optionsExcluded: []
    });
  };
  var setSelected = function (newOptions) {
    return setState(filterId, {
      id: filterId,
      mode: mode,
      optionsSelected: newOptions,
      optionsIncluded: [],
      optionsExcluded: []
    });
  };
  var setSelectedCustom = function (optionsIncluded, optionsExcluded) {
    return setState(filterId, {
      id: filterId,
      mode: "custom",
      optionsSelected: [],
      optionsIncluded: optionsIncluded,
      optionsExcluded: optionsExcluded
    });
  };
  (0, react_1.useEffect)(function () {
    var _a, _b, _c, _d, _e;
    resetEvent.on("reset", onReset);
    if (defaultMode === "custom") {
      setState(filterId, {
        id: filterId,
        mode: (_a = defaultState === null || defaultState === void 0 ? void 0 : defaultState.mode) !== null && _a !== void 0 ? _a : defaultMode,
        optionsIncluded: (_b = defaultState === null || defaultState === void 0 ? void 0 : defaultState.optionsIncluded) !== null && _b !== void 0 ? _b : defaultOptionsIncluded,
        optionsExcluded: (_c = defaultState === null || defaultState === void 0 ? void 0 : defaultState.optionsExcluded) !== null && _c !== void 0 ? _c : defaultOptionsExcluded,
        optionsSelected: []
      }, true, true);
    } else {
      setState(filterId, {
        id: filterId,
        mode: (_d = defaultState === null || defaultState === void 0 ? void 0 : defaultState.mode) !== null && _d !== void 0 ? _d : defaultMode,
        optionsSelected: (_e = defaultState === null || defaultState === void 0 ? void 0 : defaultState.optionsSelected) !== null && _e !== void 0 ? _e : defaultOptions,
        optionsIncluded: [],
        optionsExcluded: []
      }, true, true);
    }
    return function () {
      resetEvent.off("reset", onReset);
    };
  }, []);
  return {
    mode: mode,
    optionsSelected: optionsSelected,
    setMode: setMode,
    setSelected: setSelected,
    setSelectedCustom: setSelectedCustom,
    resetEvent: resetEvent,
    isActive: isActive,
    isUnsaved: isUnsaved,
    optionsIncluded: optionsIncluded,
    optionsExcluded: optionsExcluded,
    defaultState: defaultState,
    translation: translation
  };
};
exports.useFilter = useFilter;